/**
 * 404 page
 */
/* Import section */
import { Link } from "gatsby"
import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Titledecorative from "../components/titledecorative"

/* Page declaration */
const NotFoundPage = () => (
  <Layout>
    <SEO title="404 Not found - User Hello Health" description="Page not found, please refer to our homepage User Hello Health" />

    <section className="section-404">
      <div className="wrap-maincontent">
        <Titledecorative title="404 not found" />
        <p>Oops! The page you are looking for cannot be found or doesn’t exist.</p>
        <p>Not to worry, you can make your way back to our <Link to="/">homepage</Link>.</p>
      </div>
    </section>
  </Layout>
)

/* Export page informations */
export default NotFoundPage
